import React from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import { memo } from "react";

export default memo(function DateFilter({
  title,
  mode = "range", 
  placeholder = "Select date",
  value,
  onChange,
  format = "YYYY-MM-DD",
  showTime = false,
  disabled = false,
  allowClear = true,
  className = "",
  style = {},
  placeholder1 = "Start date",
  placeholder2 = "End date",
  containerClassName = "",
  label = 'abc',
  labelClassNameTop = 'block font-medium text-black',
}) {
  const inputType = showTime ? "datetime-local" : "date";

  console.log("Placeholder ::",placeholder);
  console.log("Input type ::",inputType);
  console.log("Value  ::",value);

  const handleSingleChange = (e) => {
    const val = e.target.value;
    const momentDate = val ? moment(val) : null;
    onChange?.(momentDate, val);
  };

  const handleRangeChange = (index, e) => {
    const val = e.target.value;
    const momentDate = val ? moment(val) : null;

    let newValue = Array.isArray(value) ? [...value] : [null, null];
    newValue[index] = momentDate;

    let dateStrings = newValue.map((d) => (d ? d.format(format) : ""));
    onChange?.(newValue, dateStrings);
  };

  return (
    <div className={`d-flex flex-column ${containerClassName}`}>
      <div className="text-start">
        {label ? (
          <label htmlFor={label + title} className={labelClassNameTop}>
            {label}
          </label>
        ) : null}
      </div>
      <div className={``}>

        {mode === "single" ? (
          <Form.Control
            type={inputType}
            value={value ? value.format(showTime ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD") : ""}
            onChange={handleSingleChange}
            disabled={disabled}
            placeholder={placeholder}
            className={className}
            style={style}
          />
        ) : (
          <div className="d-flex gap-2">
            <Form.Control
              type={inputType}
              value={
                Array.isArray(value) && value[0]
                  ? value[0].format(showTime ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD")
                  : ""
              }
              onChange={(e) => handleRangeChange(0, e)}
              disabled={disabled}
              placeholder={placeholder1}
              className={className}
              style={style}
            />
            <Form.Control
              type={inputType}
              value={
                Array.isArray(value) && value[1]
                  ? value[1].format(showTime ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD")
                  : ""
              }
              onChange={(e) => handleRangeChange(1, e)}
              disabled={disabled}
              placeholder={placeholder2}
              className={className}
              style={style}
            />
          </div>
        )}
      </div>
    </div>
  );
})
